import React, { useState, FunctionComponent, useRef, useEffect } from "react";
import styles from "./Dropdown.module.scss";
import {
  KeyboardArrowDownRounded,
  CheckRounded,
  KeyboardArrowUpRounded,
} from "@material-ui/icons";
import { Option } from "./DropdownTypes";
import cn from "classnames";

const Dropdown: FunctionComponent<{
  selectedValue: any;
  label: string;
  options: Option[];
  onSelected?: (option: Option) => any;
}> = ({ selectedValue, label, options, onSelected }) => {
  const [open, setOpen] = useState(false);
  const node: any = useRef();

  const handleClick = (e: MouseEvent) => {
    if (node?.current?.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  return (
    <fieldset className={styles.dropdown} ref={node}>
      <button
        className={styles.dropdown_inputBase}
        onClick={() => setOpen(!open)}
        aria-label="dropdown-button"
        type="button"
      >
        <div>
          <b className={styles.dropdown_selectedValue}>
            {selectedValue.length <= 0 && "All"}
            {selectedValue.length === 1 && selectedValue[0].label}
            {selectedValue.length > 1 && selectedValue.length}
          </b>{" "}
          <label className={styles.dropdown_label}>{label}</label>
        </div>

        {!open && (
          <KeyboardArrowDownRounded
            fontSize="default"
            style={{ color: "var(--grey-7)" }}
          />
        )}

        {open && (
          <KeyboardArrowUpRounded
            fontSize="default"
            style={{ color: "var(--grey-7)" }}
          />
        )}
      </button>

      {open && (
        <div className={styles.dropdown_list}>
          <ul>
            {options.map((option) => (
              <li className={styles.dropdown_list_item} key={option.label}>
                <button
                  type="button"
                  aria-label="dropdown-button"
                  className={cn([
                    styles.dropdown_list_item_button,
                    {
                      [styles.dropdown_list_item_button__selected]:
                        option.selected,
                    },
                  ])}
                  onClick={onSelected ? () => onSelected(option) : () => {}}
                >
                  <label>{option.label}</label>

                  {option.selected && <CheckRounded fontSize="small" />}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </fieldset>
  );
};

export default Dropdown;
